// `@ton/core` and `@tonconnect/sdk` reach for Node's `Buffer` global. Bind a
// browser polyfill onto `globalThis` before any TON module body executes —
// ES-module import hoisting guarantees this side-effect import runs first.
import "./lib/bufferPolyfill";

import React from "react";
import ReactDOM from "react-dom/client";
import { TonConnectUIProvider, THEME } from "@tonconnect/ui-react";
import { App } from "./App";
import { bootstrapTonadoCore } from "./lib/tonadoCore";
import "./styles/index.css";

// Register @tonado/core's artifact loaders before any React component
// can trigger a deposit/withdraw flow. Idempotent — safe under StrictMode's
// double-render in dev.
bootstrapTonadoCore();

// `||` not `??` - an empty-string build-arg from docker-compose passes through
// `??` and breaks TonConnect at boot ("manifestUrl required").
//
// Wallets reject the connection prompt instantly if the manifest's `url`
// doesn't match the dApp's origin (anti-phishing). The dev manifest swaps
// in localhost so vite-dev sessions can connect.
const MANIFEST_FILE = import.meta.env.DEV
  ? "tonconnect-manifest.dev.json"
  : "tonconnect-manifest.json";
const MANIFEST_URL =
  import.meta.env.VITE_TONCONNECT_MANIFEST_URL || `${window.location.origin}/${MANIFEST_FILE}`;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <TonConnectUIProvider manifestUrl={MANIFEST_URL} uiPreferences={{ theme: THEME.DARK }}>
      <App />
    </TonConnectUIProvider>
  </React.StrictMode>
);
